import React from "react";
import { getUserFromLocalStorage } from "../../login";
import LayoutBarista from "../../../layout/layout_barista";
import { User } from "../../../interfaces/user";
import History from "./components/history_page";


export function BaristaHistory() {
  const userFromLocalStorage: User = getUserFromLocalStorage();
  console.log(userFromLocalStorage);
  return (
    <>
      <LayoutBarista>
      <History/>
      </LayoutBarista>
    </>
   
  );
}

